"use client";
import React, { useEffect, useRef, useState } from "react";
import Banner from "@/components/serviceComponent/banner";
import CluthRating from "@/components/serviceComponent/cluthRating";
import Client from "@/components/serviceComponent/Client";
import QuickLinks from "@/components/serviceComponent/quickLinks";
import LeadBanner from "@/components/serviceComponent/LeadBanner";
import IndustriesSeo from "@/components/serviceComponent/industriesSeo";
import ClientSays from "@/components/CommonComponent/clientSays";
import About from "@/components/serviceComponent/about";
import CaseStudies from "@/components/serviceComponent/case-studies";
import Faq from "@/components/Home/faqComp";
import Packages from "@/components/serviceComponent/packages";
import { StyledWrapper } from "@/components/Styled";
import Technique1 from "@/components/serviceComponent/Technique1";
import Technique2 from "@/components/serviceComponent/Technique2";
import Blogs from "@/components/CommonComponent/blogs";
import Packages1 from "@/components/CommonComponent/Packages/index";
import Choose from "@/components/Home/Choose";
import MarketingServices from "@/components/serviceComponent/marketingServices";
import SeoService from "@/components/seoService";
import NewsLetter from "@/components/serviceComponent/newsLetter";
import Engagement2 from "@/components/serviceComponent/Engagement2";
import Review from "@/components/CommonComponent/revenue";
import Table from "@/components/serviceComponent/table";
import axios from "axios";
import { BASE_URL } from "@/util/api";
import Other from "@/components/Pages/OtherPage";
import CommonBanner from "@/components/CommonComponent/Common-Banner";
import Link from "next/link";
import Button from "@/components/CommonComponent/button";
import Visiblity from "@/components/serviceComponent/visiblity";
import Revenue from "@/components/CommonComponent/revenue";
import Data from "@/components/Json/Data.json";
import WebsiteReport from "@/components/OtherComponent/websiteReport";
import CustomerChoose from "@/components/CommonComponent/CustomerChoose";
import Cricial from "@/components/serviceComponent/crucial";
import { service_menu1 } from "@/Data/service_menu";
import { ChevronLeft, ChevronRight } from "lucide-react";
import ReactPlayer from "react-player";
import VideoSection from "@/components/serviceComponent/video";
import Certificate from "@/components/Home/Certificate";
import { div } from "framer-motion/client";
import { city } from "@/Data/company-city";
const SerServiceIndia = ({ data, cluth, slug, type }: any) => {
  const [activeSection, setActiveSection] = useState<any>(null);
  const [quicklinks, setquicklinks] = useState<any>();
  const menuRef = useRef<HTMLUListElement>(null);
  const fetchQuicklinks = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}quick-link/slug/?slug=${slug}/`
      );
      console;
      setquicklinks(response?.data);
    } catch (error: any) {
      // console.log('quicklinks error', error);
    }
  };
  useEffect(() => {
    fetchQuicklinks();
  }, []);

  const scrollMenu = (direction: "left" | "right") => {
    menuRef.current?.scrollBy({
      left: direction === "left" ? -250 : 250, // Adjusted for smoother scrolling
      behavior: "smooth",
    });
  };

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  useEffect(() => {
    const checkScroll = () => {
      if (!menuRef.current) return;
      const { scrollLeft, scrollWidth, clientWidth } = menuRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth);
    };
    checkScroll(); // Initial check
    menuRef.current?.addEventListener("scroll", checkScroll);
    return () => menuRef.current?.removeEventListener("scroll", checkScroll);
  }, []);
  function generateBreadcrumb(slug: any) {
    const parts = slug.split("/");
    let path = "";
    return parts.map((part: any, index: number) => {
      path += (index === 0 ? "" : "/") + part;
      const isLast = index === parts.length - 1;
      return (
        <span key={index} className="flex items-center gap-2">
          <span>&gt;</span>
          {isLast ? (
            <span className="capitalize text-gray-500">
              {part.replace(/-/g, " ")}
            </span>
          ) : (
            <Link
              href={`/${path}`}
              className="text-blue hover:text-pink hover:underline capitalize"
            >
              {part.replace(/-/g, " ")}
            </Link>
          )}
        </span>
      );
    });
  }

  // console.log("bread crumbs",generateBreadcrumb(slug));
  return (
    <>
      {type == "service" && (
        <div>
          <Banner
            image={data?.image}
            title={data?.title}
            link2={data?.link_url}
            text2={data?.link_text}
            link1={"/get-a-free-quote/"}
            text1={"Get a free quote"}
            description={data?.description}
            image_alt={data?.image_alt}
            cluth={cluth}
          />
          <Certificate props={data?.award_title} />
          {/* menu for service page */}
          {(data?.service_menu[0]?.card || service_menu1?.card) && (
            <div className="top-16 sticky z-50 w-fit max-w-[95%] lg:max-w-[75%] mx-auto mt-6">
              {/* Left Scroll Button */}
              {canScrollLeft && (
                <button
                  onClick={() => scrollMenu("left")}
                  className={`absolute left-0 top-1/2 -translate-y-1/2 bg-pinkdarker text-white shadow-md p-2 rounded-full z-50 hidden sm:block ${
                    !canScrollLeft ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                  disabled={!canScrollLeft}
                >
                  <ChevronLeft size={24} />
                </button>
              )}
              <div className="bg-white text-homeblack sticky hidden sm:flex top-16 z-40 shadow p-4 lg:px-10 rounded-full overflow-hidden">
                <ul
                  ref={menuRef}
                  className="flex gap-6 mx-5 w-full overflow-x-auto scroll-smooth whitespace-nowrap no-scrollbar"
                  style={{ scrollbarWidth: "none" }}
                >
                  {data?.service_menu[0]?.card?.map(
                    (section: any, index: number) => (
                      <a
                        key={index}
                        href={`#${section?.section_choice}`}
                        className={`relative cursor-pointer font-medium transition-colors duration-300 group ${
                          section?.section_choice === activeSection
                            ? "text-pink"
                            : "hover:text-pink"
                        }`}
                      >
                        {section?.title}
                        <span
                          className={`absolute left-0 -bottom-1 bg-pink h-[2px] transition-all duration-300 ${
                            section?.section_choice === activeSection
                              ? "w-full"
                              : "w-0 group-hover:w-full"
                          }`}
                        ></span>
                      </a>
                    )
                  )}
                  {data?.service_menu.length == 0 &&
                    service_menu1?.card?.map((section: any, index: number) => (
                      <a
                        key={index}
                        href={`#${section?.section_choice}`}
                        className={`relative cursor-pointer font-medium transition-colors duration-300 group ${
                          section?.section_choice === activeSection
                            ? "text-pink"
                            : "hover:text-pink"
                        }`}
                      >
                        {section?.title}
                        <span
                          className={`absolute left-0 -bottom-1 bg-pink h-[2px] transition-all duration-300 ${
                            section?.section_choice === activeSection
                              ? "w-full"
                              : "w-0 group-hover:w-full"
                          }`}
                        ></span>
                      </a>
                    ))}
                </ul>
              </div>
              {canScrollRight && (
                <button
                  onClick={() => scrollMenu("right")}
                  className={`absolute right-0 top-1/2 -translate-y-1/2 bg-pinkdarker text-white shadow-md p-2 rounded-full z-50 hidden sm:block ${
                    !canScrollRight ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                  disabled={!canScrollRight}
                >
                  <ChevronRight size={24} />
                </button>
              )}
            </div>
          )}

          {/* bread curms------------------------------------------------ */}
          <div className=" border-b-[1px] border-slate-200 pb-4">
            <div className="w-[98%]  xl:w-[95%] flex gap-2 py-4 h-[50px]  item-center 2xl:w-[76%] rounded-xl lg:p-6  mx-auto">
              <Link
                href="/"
                className="text-blue hover:text-pink hover:underline"
              >
                Home
              </Link>
              <div className="flex mt-3">{generateBreadcrumb(slug)}</div>
            </div>
          </div>
          {/* cluth rating----------------------------------------------- */}
          <div className="bg-lightblue lg:py-12 xl:py-20">
            <div className="w-[98%] xl:w-[95%]   bg-white 2xl:w-[76%]  rounded-xl  lg:p-6  ClutchRating mx-auto">
              <CluthRating props={cluth} />
            </div>
          </div>
          {/* about section  */}

          {(data?.aboutservice?.title ||
            data?.aboutservice?.subtitle ||
            data?.aboutservice?.description) && (
            <div className="About" id="About">
              <About props={data?.aboutservice} />
            </div>
          )}

          {/* video content section ---------------------------------------------- */}

          {data?.videocontent && <VideoSection data={data?.videocontent} />}
          {/* Testimonial------------------------------------------------- */}
          <div className="Testimonials" id="Testimonials">
            <ClientSays
              title={data?.testimonial_title}
              description={data?.testimonial_description}
              props={data?.clients_say}
            />
          </div>
          {/* brands section ---------------------------------------- */}
          <div className="Brands" id="Brands">
            <Client title={data?.brands_title} props={data?.brands[0]} />
          </div>
          {/* case studies-----------------------------------------  */}

          {data?.CaseStudies && (
            <div className="CaseStudies" id="CaseStudies">
              <CaseStudies props={data?.CaseStudies}></CaseStudies>
            </div>
          )}
          {data?.packagecategory.length > 0 && (
            <div className="Packages" id="Packages">
              <Packages
                props={data?.packagecategory}
                headtitle={data?.package_title}
                desc={data?.package_description}
              />
            </div>
          )}
          {data?.service_type?.find(
            (item: any) => item.servicetype_formate === "formate1"
          ) && (
            <div className="Service_Section" id="Service_Section">
              <Technique2
                props={data.service_type.find(
                  (item: any) => item.servicetype_formate === "formate1"
                )}
              />
            </div>
          )}

          {/* packages-------------------------- */}

          {/* engagement section 2 can see here seo/pricing/seo-packages/ */}
          <div className="engagementsection_s2" id="engagementsection_s2">
            {data?.engagementsection
              ?.filter((item: any) => item.section === "s2")
              .map((item: any, index: number) => (
                <LeadBanner key={index} props={item} />
              ))}
          </div>
          {/*why choose section -------------------------------------------- */}
          {data?.service_card3?.some(
            (card: any) => card?.serivce_card_formate === "formate3"
          ) && (
            <div className="service_card3_f3" id="service_card3_f3">
              {data?.service_card3
                ?.filter(
                  (card: any) => card?.serivce_card_formate === "formate3"
                )
                .map((filteredCard: any, index: number) => (
                  <Choose key={index} props={filteredCard} />
                ))}
            </div>
          )}

          {slug == "seo/services/keywords-research" && (
            <div>
              {data?.pricing_packages?.some(
                (pkg: any) => pkg?.package_formate === "formate3"
              ) && (
                <div className="pricing_packages" id="pricing_packages">
                  <Table props={data?.pricing_packages || []} />
                </div>
              )}
            </div>
          )}

          {/* growth section */}

          {data?.service_type?.find(
            (item: any) => item.servicetype_formate === "formate2"
          ) && (
            <div className="Growth_Section" id="Growth_Section">
              <Technique1
                props={data.service_type.find(
                  (item: any) => item.servicetype_formate === "formate2"
                )}
              />
            </div>
          )}

          {/* <div className='service_type_f1' id='service_type_f1'>
            {
              data?.service_type[0] &&
              <Technique2 props={data?.service_type[0]} />
            }
          </div> */}
          {/* constent section 2 */}

          <StyledWrapper>
            {data?.contentsection1?.description && (
              <div
                className="w-[98%] xl:w-[95%] py-20 px-4 text-[20px] leading-10  contentsection1 bg-white 2xl:w-[76%] mx-auto"
                id="contentsection1"
                dangerouslySetInnerHTML={{
                  __html: data?.contentsection1?.description,
                }}
              />
            )}
          </StyledWrapper>
          <div
            className="engagementsection_s3 border-y-2 border-lightblue"
            id="engagementsection_s3"
          >
            {data?.engagementsection
              ?.filter((item: any) => item.section === "s3")
              .map((item: any, index: number) => (
                <Engagement2 key={index} props={item} />
              ))}
          </div>
          {data?.contentsection2?.description && (
            <StyledWrapper>
              <div
                className="w-[98%] xl:w-[95%] py-20 text-[20px] leading-10 contentsection2   bg-white 2xl:w-[76%] mx-auto"
                id="contentsection2"
                dangerouslySetInnerHTML={{
                  __html: data?.contentsection2?.description,
                }}
              />
            </StyledWrapper>
          )}

          {/* content section 1-------------------------------------------- */}
          {/* content secttion 3---------------------- */}
          {data?.contentsection3?.description && (
            <StyledWrapper>
              <div
                className="w-[98%] xl:w-[95%] py-20 text-[20px] leading-10  contentsection3 bg-white 2xl:w-[76%] mx-auto"
                id="contentsection3"
                dangerouslySetInnerHTML={{
                  __html: data?.contentsection3?.description,
                }}
              />
            </StyledWrapper>
          )}

          {/* about service data ------------------------------- */}

          {data?.service_card2.length > 0 && (
            <div className="service_card2" id="service_card2">
              <MarketingServices props={data?.service_card2[0]} />
            </div>
          )}

          {slug != "seo/services/keywords-research" && (
            <div>
              {data?.pricing_packages?.some(
                (pkg: any) => pkg?.package_formate === "formate3"
              ) && (
                <div className="pricing_packages" id="pricing_packages">
                  <Table props={data?.pricing_packages || []} />
                </div>
              )}
            </div>
          )}

          {data?.service_card3?.some(
            (card: any) => card?.serivce_card_formate === "formate1"
          ) && (
            <div className="service_card3_f1" id="service_card3_f1">
              {data?.service_card3
                ?.filter(
                  (card: any) => card?.serivce_card_formate === "formate1"
                )
                .map((filteredCard: any, index: number) => (
                  // <Choose key={index} props={filteredCard} />
                  <MarketingServices key={index} props={filteredCard} />
                ))}
            </div>
          )}
          {data?.service_card1.length > 0 && (
            <div className="service_card1" id="service_card1">
              <SeoService props={data?.service_card1[0]} />
            </div>
          )}
          {/* add 19) table type here */}
          <div className="engagementsection_s1" id="engagementsection_s1">
            {data?.engagementsection
              ?.filter((item: any) => item.section === "s1")
              .map((item: any, index: number) => (
                <Review cards={data.engagementcard} props={item} key={index} />
              ))}
          </div>

          {data?.service_card3?.some(
            (card: any) => card?.serivce_card_formate === "formate2"
          ) && (
            <div className="Industry" id="Industry">
              {data?.service_card3
                ?.filter(
                  (card: any) => card?.serivce_card_formate === "formate2"
                )
                .map((filteredCard: any, index: number) => (
                  <IndustriesSeo
                    key={index}
                    industries={filteredCard?.card}
                    title={filteredCard?.title}
                    subtitle={filteredCard?.subtitle}
                  />
                ))}
            </div>
          )}
          {data?.service_packages_faq?.card?.length > 0 && (
            <div className="Faq" id="Faq">
              <Faq
                props={data?.service_packages_faq?.card || []}
                title={data?.service_packages_faq?.title}
              />
            </div>
          )}
          <NewsLetter />
          {quicklinks && (
            <div className="QuickLinks" id="QuickLinks">
              <QuickLinks
                props={quicklinks?.link_category}
                title={quicklinks?.title}
              />
            </div>
          )}
          <div className="Blogs" id="Blogs">
            <Blogs props={data?.blog} />
          </div>
          {slug?.replace(/\/+$/, '') === "seo/company" && (
            <div className="bg-white flex justify-between gap-3 xl:w-[79%] mx-auto px-4 w-full mb-10">
              <div className="w-full rounded-xl bg-lightblue border-slate-100 border-[1px] h-full py-8 px-2 lg:px-6 shadow-lg">
                <p className="text-homeblack font-bold text-center mb-5">
                  Best SEO Company – Find Out Tops the List
                </p>
                <div className="flex justify-center flex-wrap gap-4">
                  {city?.map((elem: any, index: number) => (
                    <Link
                      key={index}
                      href={elem.link}
                      className="py-2 lg:py-4 border-[1px] hover:text-pink border-blue text-[16px] lg:text-[18px]
                                       bg-white flex justify-center hover:border-pink items-center w-fit lg:w-[22%]
                                        text-blue font-bold hover:bg-lightpink px-4 rounded hover:bg-blue-600 transition duration-300"
                    >
                      {elem?.city}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {type == "package" && (
        <div className="w-full">
          <CommonBanner
            title={data?.title}
            status={"true"}
            description={data?.description}
            image={data?.image}
            image_alt={data?.image_alt}
            btntext={data?.link_text}
            btnlink={data?.link_url}
          />
          {/* {
            data?.packagecategory.length > 0 &&
            <div className='Packages'>
              <Packages props={data?.packagecategory} />
            </div>
          } */}
          {data?.clients_say && <ClientSays props={data?.clients_say} />}
          <div className="w-full bg-blue py-10 !text-white  lg:py-16">
            <div className=" md:w-[75%] mx-auto xl:w-[50%]">
              <p className=" text-[28px] font-bold text-center lg:leading-[46px] lg:text-[38px]">
                Get A Top Rank on Google Search Results, Qualified Leads and
                Increased Sales
              </p>
              <div className="flex flex-wrap mt-8 justify-center gap-4">
                <Link href="/get-a-free-quote">
                  <Button content={"Get a Quote Now!"} />
                </Link>
                {/* <Link href="/get-a-free-strategy-review"></Link> */}
                <Link href="/get-a-free-strategy-review">
                  <Button content={"Analyse your Website for Free!"} />
                </Link>
              </div>
            </div>
          </div>
          {data?.contentsection1?.description && (
            <div className="w-full mx-auto xl:w-[95%] contentsection1  2xl:w-[80%] flex flex-col gap-4 px-6  py-12">
              <StyledWrapper>
                <div
                  className=""
                  dangerouslySetInnerHTML={{
                    __html: data?.contentsection1?.description,
                  }}
                />
              </StyledWrapper>
            </div>
          )}
          {data?.packagecard1.card?.length > 0 && (
            <Visiblity props={data?.packagecard1} />
          )}
          <Revenue props={Data.revenue} cards={Data.revenue.cards} />
          {data?.service_packages_faq?.title &&
            data?.service_packages_faq?.card?.length > 0 && (
              <div className="Faq">
                <Faq
                  props={data?.service_packages_faq?.card}
                  title={data?.service_packages_faq?.title}
                />
              </div>
            )}
          <WebsiteReport />
          <div className="Choose">
            <CustomerChoose />
          </div>
          {slug == "keywords-research" &&
            data?.pricing_packages?.some(
              (pkg: any) => pkg?.package_formate === "formate3"
            ) && (
              <div className="pricing_packages" id="pricing_packages">
                <Table props={data?.pricing_packages || []} />
              </div>
            )}
          {data?.our_package.length > 0 && (
            <Packages1 props={data?.our_package} />
          )}
          {data?.packagecard2.card?.length > 0 && (
            <Cricial props={data?.packagecard2} />
          )}
          <div className="bg-blue text-white w-full py-12 lg:py-16">
            <div className=" mx-auto w-full md:w-[75%] lg:w-[55%]">
              <p className=" text-[28px] leading-tight md:leading-normal mb-4 md:text-[38px] font-semibold text-center">
                Want to know the SEO score of your website for free?
              </p>
              <p className="text-[18px] text-center leading-[21px]">
                Try our free Website Analyzer Tool that will show you the SEO
                report. In this report, you will discover whether your website
                is optimized for the keywords you have used.
              </p>
              <div className="flex justify-center items-center mt-9">
                <Link href={"/get-a-free-quote"}>
                  <Button content={"Get a Free SEO Report"} />
                </Link>
              </div>
            </div>
          </div>
          {quicklinks && (
            <QuickLinks
              props={quicklinks?.link_category}
              title={quicklinks?.title}
            />
          )}
          <Blogs props={data?.blog} />
        </div>
      )}
      {type == "other_pages" && <Other other={data} />}
    </>
  );
};
export default SerServiceIndia;
